<template>
  <button
    class="slide-button"
    :class="[`slide-button_${type}`]"
    type="button"
  >
    <span class="content">
      <svg
        width="10"
        height="16"
        viewBox="6 0 10 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.09619 14L14 8.09619L8.09619 2.19238"
          stroke="#969698"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </span>
  </button>
</template>

<script lang="ts">
  import type { PropType } from 'vue';

  export default defineNuxtComponent({
    name: 'SlideButton',

    props: {
      type: {
        type: String as PropType<'left' | 'right'>,
        default: 'left',
      },
    },
  });
</script>

<style lang="scss" scoped>
  .slide-button {
    border: 8px solid transparent;
    background-color: transparent;
    border-radius: 50%;
    cursor: pointer;

    &_right svg {
      transform: translateX(1px);
    }
    &_left svg {
      transform: rotate(180deg) translateX(1px);
    }

    @include hover() {
      .content {
        box-shadow: 0 8px 16px rgba(0, 0, 0, 0.25);
      }

      svg path {
        stroke: black;
      }
    }
  }

  .content {
    display: flex;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: #fff;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.25);
    outline: none;
    transition: 0.1s box-shadow ease-in-out;

    svg {
      display: block;
      margin: auto;

      path {
        transition: 0.1s stroke ease-in-out;
      }
    }
  }
</style>
